<div class="flex">
	<app-radio-group
		*ngIf="documentTypesList?.length"
		class="mt-4"
		type="compact"
		[items]="documentTypesList"
		[label]="showLabels ?? 'Document type'"
		(ngModelChange)="onSelectDocumentType($event)"
		[ngModel]="selectedDocumentTypeName"
	></app-radio-group>
</div>
<app-radio-group
	*ngIf="chargeTypesList?.length"
	[label]="showLabels ?? 'Charge type'"
	class="mt-4"
	type="compact"
	[items]="chargeTypesList"
	(ngModelChange)="onSelectChargeType($event)"
	[ngModel]="selectedChargeTypeName"
></app-radio-group>
